import { useState } from 'react';

/**
 * Renders an avatar from either an image URL or an emoji/character fallback.
 * Prevents displaying URL strings or base64 fragments as visible text.
 */
export function AvatarDisplay({
  src,
  alt,
  fallback = '👤',
  className = '',
  containerClassName = '',
}: {
  src?: string;
  alt: string;
  fallback?: string;
  className?: string;
  containerClassName?: string;
}) {
  const [imgError, setImgError] = useState(false);

  const isImageUrl =
    src &&
    !imgError &&
    (src.startsWith('http://') ||
      src.startsWith('https://') ||
      src.startsWith('data:'));
  const isGarbage =
    src &&
    src.length > 20 &&
    /^[a-zA-Z0-9+/=_-]+$/.test(src) &&
    !src.startsWith('http') &&
    !src.startsWith('data:');

  const baseContainerClass = `rounded-full flex items-center justify-center overflow-hidden flex-shrink-0 ${containerClassName}`;
  const gradientStyle = {
    background: 'linear-gradient(135deg, #F0EFF5 0%, #936FEF 100%)',
  };

  if (isImageUrl) {
    return (
      <div className={baseContainerClass} style={gradientStyle}>
        <img
          src={src}
          alt={alt}
          className={`w-full h-full object-cover ${className}`}
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  const displayContent = !src || isGarbage ? fallback : src;
  return (
    <div className={baseContainerClass} style={gradientStyle}>
      <span className={className}>{displayContent}</span>
    </div>
  );
}
